export default __webpack_public_path__ + "static/media/pic1.bb23f4ec.jpg";